import { useLocation } from "@tanstack/react-router";
import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import { userRequiresPolicyConsent } from "@/lib/lutely-api/hooks/usePolicyConsent";
import { userRequiresEmailVerification } from "@/lib/lutely-api/hooks/useEmailVerification";
import { getImpersonateEmail } from "@/lib/storage-utils";
import EmailVerificationGate from "./EmailVerificationGate";

export default function EmailVerificationGateContainer() {
  const { data: currentUser, isLoading } = useLoggedInUser();
  const location = useLocation();

  // Not keyed on `isFetching`: every background refetch of /auth/me would
  // otherwise tear this blocking dialog down and rebuild it under the user.
  // `isPaused` leaves the user undefined during signup, which `!currentUser`
  // already covers.
  if (isLoading || !currentUser) {
    return null;
  }

  // Policy consent goes first — see PersonaPickerContainer for why stacking
  // two blocking dialogs breaks scrolling in the lower one.
  if (userRequiresPolicyConsent(currentUser)) {
    return null;
  }

  // /auth/verify-email resolves verification; covering it would deadlock.
  if (location.pathname.startsWith("/auth")) {
    return null;
  }

  // Impersonation swaps the user server-side but leaves the session as the
  // admin's, so the server can't report the impersonated user's verification
  // state — and any code sent or entered here would act on the admin.
  if (getImpersonateEmail()) {
    return null;
  }

  if (!userRequiresEmailVerification(currentUser)) {
    return null;
  }

  return <EmailVerificationGate />;
}
